<template>
	<div class="containerBox">
		<div class="home-box">
			<div class="left-box">  
				<el-image :src="dealersIcon" class="logo" v-if="dealersIcon"></el-image>
				<img class="logo" :src="defaultIcon" v-else></img>
			</div>
			<div class="right-box">
				<div class="head-box">
					<div class="head-tab">
						<el-tabs type="card" v-model="activeTab" @tab-click="tabChange" stripe>
							<el-tab-pane label="Bug submission" name="one">
								<div class="step-box">
									<div class="content-box">
										<span class="step-title">Buggy system</span>
										<span class="content">You can provide feedback or inquire about the vulnerabilities
											encountered through this website，The administrator will reply within 5 working
											days. The problem handling will be completed within three months, and the right to interpret belongs to the manufacturer.</span>
										<span class="content">High Risk: The vulnerability may lead to complete system control, data leakage, device damage, and other serious consequences. It usually requires immediate fixing. The patch time is within 7 days, and the complete resolution time depends on the after-sales response. The criteria for judgment are that it affects the machine, causing it to be unusable.</span>
										<span class="content">Medium Risk: The vulnerability may cause partial system function failure, data tampering, and other moderate impacts. It needs to be fixed as soon as possible. The resolution time is within 30 days. The criteria for judgment are that it affects performance but the machine can still be used normally.</span>
										<span class="content">Low Risk: The vulnerability has a minor impact and may cause some non-critical functions to malfunction. It can be fixed in the next version. The resolution time is within 7 days or as per the after-sales response. The criteria for judgment are that it neither affects performance nor usage.</span>
										<div class="item-box">
											<div class="step-item" :key="index +'step'" v-for="(item,index) in stepArr">
												<div class="circle">{{item.value}}</div>
												<span class="title">{{item.title}}</span>
											</div>
										</div>
										<div class="holes-btn pointer" @click="holesDialogVisible = true">Start filling in the holes</div>
									</div>
									
								</div>
								
								
							</el-tab-pane>
							<el-tab-pane label="Submit query" name="two">
								<div class="check-box" v-if="!detailStatus">
									<div class="input-box">
										<span class="marginRight8">E-mail:</span>
										<el-input v-model="checkEmail" maxlength="80"
											style="width: 427px;margin-right: 20px;"
											placeholder="Please input the email address." show-word-limit></el-input>
										<div class="submit-btn pointer" @click="checkMistakeInfo">Submit</div>
										<div class="reset-btn pointer marginLeft20" @click="reset">Reset</div>
									</div>
									<div class="table-box" v-if="tableData.length">
										<el-table :data="tableData" v-loading="loading" stripe style="width: 1100px;">
											<template slot="empty">
												<div class="noDataTip">
													<img src="../../../static/img/engineering_icon_empty.png" alt="" />
													<span>No content backup</span>
												</div> 
											</template>
											<el-table-column prop="mistakeTitle" label="MistakeTitle" align="left">
												<template slot-scope="scope">
													<span class="color-blue pointer button-hover" @click="getMistakeDetail(scope.row)">{{scope.row.mistakeTitle||'--'}}</span>
												</template>
											</el-table-column>
											<el-table-column prop="createTime" label="CreateTime" align="left">
												<template slot-scope="scope">
													<span class="pointer">{{scope.row.createTime||'--'}}</span>
												</template>
											</el-table-column>
											<el-table-column prop="mistakeStatus" label="MistakeStatus" align="left">
												<template slot-scope="scope" class="pointer">
													<span v-if="scope.row.mistakeStatus == '0'">Pending</span>
													<span v-else-if="scope.row.mistakeStatus == '1'">Processing</span>
													<span v-else-if="scope.row.mistakeStatus == '2'">It has been fixed</span>
													<span v-else-if="scope.row.mistakeStatus == '3'">Not a loophole</span>
													<span v-else-if="scope.row.mistakeStatus == '4'">Refuse to fix</span>
													<span v-else>To be confirmed</span>
												</template> 
											</el-table-column>
											<el-table-column prop="mistakeReply" label="Official reply" align="left">
												<template slot-scope="scope">
													<span class="pointer">{{scope.row.mistakeReply||'--'}}</span>
												</template>
											</el-table-column>
										</el-table>
									</div>
									<div class="flex-center" v-else>
										<div class="noDataTip" style="margin: 0 auto;">
											<img src="../../../static/img/engineering_icon_empty.png" />
											<span>No content backup</span>
										</div>
									</div>
				
								</div>
								<div class="check-box" v-else>
									<div class="top-title">
										<div class="iconfont el-icon-back fontSize20 marginRight8 pointer" @click="feedbackList"></div>
										<span class="mistake-title fontSize20 color-black">{{mistakeInfo.mistakeTitle}}</span>
										<div class="fontSize20 color-gray" v-if="mistakeInfo.mistakeStatus == '0'">（Pending）</div>
										<div class="fontSize20 color-gray" v-else-if="mistakeInfo.mistakeStatus == '1' ">（Processing）</div>
										<div class="fontSize20 color-gray" v-else-if="mistakeInfo.mistakeStatus == '2' ">（Already fixed）</div>
										<div class="fontSize20 color-gray" v-else-if="mistakeInfo.mistakeStatus == '3' ">（Not a loophole）</div>
										<div class="fontSize20 color-gray" v-else-if="mistakeInfo.mistakeStatus == '4' ">（Refuse to fix）</div>
										<div class="fontSize20 color-gray" v-else-if="mistakeInfo.mistakeStatus == '5' ">（To be confirmed）</div>
									</div>
									<div class="image-box">
										<div class="flex-between">
											<div class="mistake-content fontSize14">{{mistakeInfo.mistakeContent}}</div>
											<div class="fontSize14 ">{{mistakeInfo.createTime}}</div> 
										</div>
										<div style="display: flex;">
											<div :key="index + 'img'" v-for="(item,index) in mistakeImg">
												<el-image :src="item.fileUrl" class="image-item"></el-image>
											</div>
										</div>
										<div style="margin: 15px 0;" :key="vIndex +'video'" v-for="(vItem,vIndex) in mistakeVideo">
											<video :src="vItem.fileUrl" autoplay muted loop class="video-box"></video>
										</div>
									</div>
									<div class="reply-content">
										<div class="reply-title flex-between">
											<div class="fontSize20">Official reply</div>
											 <div class="fontSize14 marginRight58">{{mistakeInfo.replyTime}}</div> 
										</div>
										<el-input type="textarea" v-model="mistakeInfo.mistakeReply" disabled  maxlength="1000"
											 show-word-limit v-if="mistakeInfo.mistakeReply"></el-input>
										<div class="noDataTip" v-else>
											<img src="../../../static/img/engineering_icon_empty.png" />
											<span>No reply yet, please wait patiently</span>
										</div>
									</div>
								</div>
							</el-tab-pane>
							<el-tab-pane label="Latest fix" name="three">
								<div class="fix-box" v-loading="fixLoading">
									<div class="fix-item" v-if="logList&&logList.length">
										<div class="item" :key="index + 'log'" v-for="(item,index) in logList" >
											<span class="colorBlack fontSize20">Version number：{{item.version}}  Version launch time：{{item.createTime}}</span>
											<div style="display: flex;align-items: baseline;" class="marginTop16">
												<div class="circle-black marginRight8"></div>
												<div class="fontSize14 marginBottom32" style="width: 90%;">
												<!-- {{item.reply||'--'}} -->
												<p v-html="formatText(item.reply)"></p>
											</div>
											</div>
										</div>
				
									</div>
									<div class="flex-center" v-else>
										<div class="noDataTip">
											<img src="../../../static/img/engineering_icon_empty.png" />
											<span>no data</span>
										</div>
									</div>
								</div>
							</el-tab-pane>
							<el-tab-pane label="Software Updates" name="four"> 
								<div class="software-box" >
									<span class="head-title">Software Updates</span>
									<span class="head-content">Our company will not shorten the software support period of the product. If the software support period is extended, the support period on the official website will be updated before the end of the support period.</span>
									<div class="search-box flex-start">
										<div class="search-item">
											<span class="fontSize14">Product model：</span>
											<el-input v-model="searchKey.productModel" placeholder="Please enter the product model" style="width: 250px;"
												@keyup.native.enter="searchDate"></el-input>
										</div>
										<div class="search-item">   
											<div class="submit-btn marginRight18" @click="searchDate">Search</div>
											<div class="cancel-btn" @click="resetKey">Reset</div>
										</div>
									</div>
									<div v-loading="product.loading">
										<el-table :data="productMaintList"  class="marginTop16"  stripe>
											<template slot="empty">
												<div class="noDataTip">
													<img src="../../../static/img/engineering_icon_empty.png" alt="" />
													<span>No content backup</span>
												</div> 
											</template>
											<el-table-column label="Product model" align="left">
												<template slot-scope="scope">
													<span>{{scope.row.productModel}}</span>
												</template>
											</el-table-column>
											<el-table-column label="Support period" align="left">
												<template slot-scope="scope">
													<span>{{scope.row.periodCount}}</span>
												</template>
											</el-table-column>
											<el-table-column label="Guaranteed software updates until" align="left">
												<template slot-scope="scope">
													<span>{{scope.row.availability}}</span>
												</template>
											</el-table-column>
											
										</el-table>
										<el-pagination @current-change="pageCurrentChange" @size-change="handleSizeChange"
											:current-page.sync="page.pageIndex" :page-size="page.pageSize"
											:page-sizes="[10, 20, 30, 50, 100, 200]" :total="page.total"
											layout="sizes, prev, pager, next, total, jumper">
										</el-pagination>
									</div>
									
								</div>
								
							</el-tab-pane>
						</el-tabs>
				
					</div>
				</div>
			</div>
			 
			<div style="width: 18%;"></div>
			<el-dialog :visible.sync="holesDialogVisible" width="1220px" :close-on-click-modal="false">
				<div class="submit-box">
					<div style="display: flex;padding: 0px 48px 30px 20px;">
						<div class="line"></div>
						<span class="colorBlack fontSize24">Submit a vulnerability</span>
					</div>
					<div>
						<el-form ref="form" :rules="rules" :model="form" label-width="108px"
							label-position="left" class="marginLeft20">
							<el-form-item label="E-mail:" prop="email">
								<el-input v-model="form.email" maxlength="80" style="width: 427px;"
									placeholder="Please input the email address."
									show-word-limit></el-input>
							</el-form-item>
							<el-form-item label="Title:" prop="title">
								<el-input v-model="form.title" maxlength="100" style="width: 800px;"
									placeholder="Please enter a title." show-word-limit></el-input>
							</el-form-item>
							<el-form-item label="Description:" prop="description">
								<el-input type="textarea" v-model="form.description" style="width: 800px;" maxlength="1000"
									placeholder="Please enter a vulnerability description" show-word-limit></el-input>
							</el-form-item>
							<div>
								<div style="margin-bottom: 20px;">Upload picture
									<span class="color-gray">(Optional，Only jpeg and png formats are
										supported, up to 5 pictures can be uploaded, each picture does not
										exceed 5MB)</span>
								</div>
								<div style="display: flex;">
									<div class="img-item pointer" :key="index +'pic'"
										v-for="(item,index) in pictureArr">
										<el-image style="width: 100%; height: 100%" :src="item.fileUrl"
											@click="magnifyPic(item.fileUrl,index)">
										</el-image>
										<div class="iconfont el-icon-error pic-del pointer"
											@click.stop.prevent="delFileImg(item,index,'pic')"></div>
									</div> 
									<el-upload ref="imgUpload" action="string" v-if="pictureArr.length < 5"
										list-type="picture-card" :show-file-list="false" :multiple="false"
										v-loading="upload.picLoading" accept=".jpg,.png" :http-request="(params) =>pictureUpload(params,'pic')">
										<img src="../../../static/img/upload.png" style="uploadImg" />
									</el-upload>
								</div>
								
							</div>
							<div style="margin-top: 55px;">
								<div style="margin-bottom: 20px;">Video upload
									<span class="color-gray">(Optional，The size does not exceed 50MB)</span>
								</div>
								<div style="display: flex;">
									<div class="marginRight20 pointer" style="position: relative;" :key="index + 'video'" v-for="(vItem,index) in uploadVideo">
										<video :src="vItem.fileUrl" autoplay muted loop class="video-box"></video>
										<div class="iconfont el-icon-error video-del pointer"
											@click.stop.prevent="delFileImg(vItem,index,'video')"></div>
									</div>
									<el-upload ref="videoUpload" v-if="uploadVideo.length<1" action="/upload-video"
										list-type="picture-card" v-loading="upload.videoLoading"
										:show-file-list="false" :before-upload="beforeUpload"  
										:multiple="false" accept=".mp4,.mov,.avi,.mkv,.Ogg"
										:http-request="(params) =>videoUpload(params,'video')">
										<img src="../../../static/img/upload-radio.png" style="uploadImg" />
									</el-upload>
								</div>
								
								
							</div>
						</el-form>
					</div>
					<div class="flex-center marginTop16">
						<div class="submit-btn pointer " @click="submitClick('form')">Submit</div>
						<div class="cancel-btn pointer marginLeft20" @click="holesDialogVisible = false">Cancel</div>
					</div>	
					
				</div>
			</el-dialog>

		</div>
		<!--图片放大器-->
		<magnify :boxVisible="magnifyItem.show" @close-box="magnifyItem.show = false" :imgUrl="magnifyItem.url"
			:nowIndex="magnifyItem.nowIndex" :picLength="magnifyItem.total"></magnify>

	</div>
</template>

<script>
	import md5 from 'js-md5';
	import api from '@/utils/api';
	import magnify from '../../components/common/magnify.vue'
	import {
		compressPic
	} from '../../utils/compressPic.js';
	import {
		Upload
	} from 'element-ui';

	export default {
		name: 'home',
		components: {
			magnify
		},
		data() {
			let validateEmail = (rule, value, callback) => {
				if (!value) {
					callback(new Error('Please enter your email'));
				} else if (!(/@/.test(value))) {
					callback(new Error("Incorrect email format"));
				} else {
					callback();
				}
			};
			return {
				defaultIcon: '../../../static/img/logo.png',
				activeTab: 'one',
				stepArr: [{
					title: 'Submit a vulnerability',
					value: '1',
				}, {
					title: 'The administrator contacts the user to communicate and confirm',
					value: '2',
				}, {
					title: 'Development team evaluates solutions',
					value: '3',
				}, {
					title: 'Update complete',
					value: '4',
				}],
				pictureArr: [], 
				uploadVideo: [],
				form: {
					email: "",
					title: "",
					description: "",
				},

				magnifyItem: {
					show: false,
					url: '',
					nowIndex: '',
					total: '',
				},
				rules: {   
					email: [{
						required: true,
						validator: validateEmail,
						trigger: 'blur'
					}],
					title: [{
						required: true,
						message: 'Please enter a title',
						trigger: 'blur'
					}],
					description: [{
						required: true,
						message: 'Please enter a vulnerability description',
						trigger: 'blur'
					}],
				},
				checkEmail: '',
				tableData: [],
				loading: false,
				dealersId: '',
				upload: {  
					videoLoading: false,
					picLoading: false,
				},
				dealersIcon: '',
				logList: [],
				detailStatus: false,
				mistakeInfo: '',
				mistakeImg: [],
				mistakeVideo: [],
				fixLoading:false,
				holesDialogVisible: false,
				page: {
					total: 0,
					pageSize: 10,
					pageIndex: 1,
				},
				productMaintList: [],
				product: {  
					loading: false,
				},
				searchKey: {
					productModel: '',
				},
			}
		},
		computed: {},
		mounted() {
			this.getParamDealersId();
			this.getMsgByDealersId();
		},
		created() {

		},
		methods: {
			getParamDealersId() {
				var url = window.location.href; 
				let queryString = url.split('?')[1];  //获取url中查询字符串部分
				let id = atob(queryString);  //base64解码
				this.dealersId = id.split('phnix')[0];  //截取没有‘phnix’字符串
			},
			getMsgByDealersId(){
				let currentTimestamp = Math.floor(Date.now() / 1000);
				let params = {
					"dealersId": this.dealersId,
					"signature": currentTimestamp
				}
				this.$axios.post(api.getMsgByDealersId,params).then(res => {
					if (res.data.error_code == '0') {
						this.dealersIcon = res.data.objectResult.dealersIcon;
					}
				})
				
			},
			formatText(text){
				return text.replace(/\n/g, '<br>');
			},
			tabChange() {
				let activeTab = this.activeTab;
				switch (activeTab) {
					case 'two':
					    this.detailStatus = false;
						this.checkEmail = '';
						this.checkMistakeInfo();
						break;
					case 'three':
					    this.detailStatus = false;
						this.checkEmail = '';
						this.getBugFixList();
						break;
					case 'four':
						this.detailStatus = false;
						this.checkEmail = '';
					   this.getProductMaintList();
				}
			},
			submitClick(formName) { 
				this.$refs[formName].validate((valid) => {
					if (valid) {
						let params = {
							"dealersId": this.dealersId,
							"contacts": this.form.email,
							"mistakeTitle": this.form.title, 
							"mistakeContent": this.form.description,  
							"mistakeImg": JSON.stringify(this.pictureArr),
							"mistakeVideo": JSON.stringify(this.uploadVideo),
						}
						
						this.$axios.post(api.addMistakeInfo, params).then((res) => {
							if (res.data.error_code == 0) {
								this.$message.success('New successfully added！')
								this.form = {
									email: "",
									title: "",
									description: ""
								}
								this.pictureArr = [];
								this.uploadVideo = [];
								this.holesDialogVisible =false;
							}else {
								this.$message.warning(res.data.error_msg)
							}
						})
						}
					})
				
			},
			pictureUpload(fileItem,type) {
				let self = this;
				console.log(fileItem)
				let imgSize = Number(fileItem.file.size / 1024 / 1024);
				if(imgSize > 5){
					this.$message.warning('The image size cannot exceed 5M');
					this.$refs.imgUpload.clearFiles();
					return;
				}
				this.upload.picLoading = true;
				self.uploadFile(fileItem.file,type, (res) => {
					this.upload.picLoading = false;
					let imgRes = {
						// 'fileType': pictureArr.fileType,
						'fileUrl': res.url,
						'fileName': res.fileName
					};
					self.pictureArr.push(imgRes);

				});
			},
			videoUpload(param, type) {
				let self = this;
				let videoSize = Number(param.file.size / 1024 / 1024);
				if(videoSize > 50){
					this.$message.warning('The size does not exceed 50MB');
					this.$refs.videoUpload.clearFiles();
					return;
				}
				console.log(param.file, 'param')
				self.upload.videoLoading = true;
				self.uploadFile(param.file,type, (res) => {
					this.upload.videoLoading = false;
					let videoRes = {
						'fileUrl': res.url,
						'fileName': res.fileName
					}
					self.uploadVideo.push(videoRes);
				});
			},
			//上传图片
			uploadFile(file,type, cb) {
				if(type == 'pic'){
					let param = new FormData() // 创建form对象
					compressPic(file, 0.6).then(pic => {
						param.append('file', pic);
						let config = {
							headers: {
								'Content-Type': 'multipart/form-data'
							}
						}
						this.picLoading = true;
						this.$axios.post(api.uploadFileImg, param, config).then(res => {
							this.picLoading = false;
							if (res.data.error_code == '0') {
								cb(res.data.objectResult);
							}
						}).catch(err => {
							console.log(err)
						})
					});
				}else {
					let param = new FormData() // 创建form对象
					param.append('file', file);
					let config = {
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					}
					this.$axios.post(api.uploadFileImg, param, config).then(res => {
						if (res.data.error_code == '0') {
							cb(res.data.objectResult);
						}
					}).catch(err => {
						console.log(err)
					})
				}
				
			},
			//放大图片
			magnifyPic(url, index) {
				this.magnifyItem = {
					show: true,
					url: url,
					nowIndex: index + 1,
					// total: total
				};
			},
			delFileImg(item, index,type) {
				console.log(item.fileName)
				this.$axios.post(api.delFileImg, {
					fileName: item.fileName
				}).then((res) => {
					if (res.data.error_code == '0') {
						if(type == 'pic'){
							this.pictureArr.splice(index, 1);
							this.$message.success('Image deleted successfully！')
						}else {
							this.uploadVideo.splice(index, 1);
							this.$message.success('Video deleted successfully！')
						}
						
					}
				}).catch((err) => {});
			},
			getFileName(fileUrl) {
				// 正则表达式匹配
				const regex = /\/([^/]+)\?/;
				const match = fileUrl.match(regex);
				if (match) {
					const fileName = match[1];
					return fileName;
				} else {
					console.log("File name not found");
				}
			},
			beforeUpload(file) {
				const maxSize = 50 * 1024 * 1024;
				if (file.size > maxSize) {
					this.$message.warning('Video size cannot exceed 50MB');
					return false;
				}
			},
			
			
			checkMistakeInfo(){
				let params = {
					"dealersId": this.dealersId||'1308664581198970880',
					"contacts": this.checkEmail,
				}
				this.loading = true;
				this.$axios.post(api.checkMistakeInfo,params).then(res=>{
					if (res.data.error_code == '0') {
						this.tableData = res.data.objectResult;
						this.loading = false;
					}else {
						this.$message.warning(res.data.error_msg)
					}
				})
			},
			
			getBugFixList(){
				let params = {}
				this.fixLoading = true;
				this.$axios.post(api.getBugFixList,params).then(res=>{
					if (res.data.error_code == '0') {
						this.logList = res.data.objectResult;
						this.fixLoading = false;
					}else {
						this.$message.warning(res.data.error_msg)
					}
				})
			},
			reset(){
				this.checkEmail = "";
				this.checkMistakeInfo();
			},
			//返回漏洞反馈页面
			feedbackList(){
				this.detailStatus = false;
				this.mistakeImg = [];
				this.mistakeVideo = [];
				this.mistakeInfo = '';
			},
			getMistakeDetail(item){
				let params = {
					mistakeId: item.mistakeId
				}
				this.$axios.post(api.getBugFeedBackInfo,params).then((res)=>{
					if (res.data.error_code == '0') {
						this.detailStatus = true;  
						this.mistakeInfo = res.data.objectResult;
						let mistakeImg = res.data.objectResult.mistakeImg;
						let mistakeVideo = res.data.objectResult.mistakeVideo;
						if(mistakeImg.length){
							this.mistakeImg = JSON.parse(mistakeImg);
						}
						if(mistakeVideo.length){
							this.mistakeVideo = JSON.parse(mistakeVideo);
						}
					}else {
						this.$message.warning(res.data.error_msg)
					}
				})
			},
			getProductMaintList(){
				let params = {
					"pageIndex": this.page.pageIndex,
					"pageSize": this.page.pageSize,
					"productModel": this.searchKey.productModel,
				}
				this.product.loading = true;
				this.$axios.post(api.getProductMaintList,params).then((res)=>{
					if (res.data.error_code == '0') {
						this.product.loading = false;
						this.productMaintList = res.data.objectResult;
						this.page.total = res.data.totalSize;
					}else {
						this.$message.warning(res.data.error_msg)
					}
				})
			},
			handleSizeChange(val) {
				this.page.pageSize = val;
				this.page.pageIndex = 1;
				this.getProductMaintList();
			},
			pageCurrentChange(val) {
				this.page.pageIndex = val;
				this.getProductMaintList();
			},
			searchDate(){
				this.getProductMaintList();
			},
			resetKey(){
				this.searchKey.productModel = "";
				this.getProductMaintList();
			},
		},

		beforeDestroy() {
			if (this.loginTimer) {
				this.loginTimer = null;
			}
			clearInterval(this.loginTimer);
		}
	}
</script>

<style scoped>
	.containerBox {}

	.flex-center {
		display: flex;
		align-items: center;
	}

	.home-box {
		display: flex;
		background: #292B33;
	}
	.left-box {
		width: 18%;
		height: 66px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.logo {
		width: 52px;
		height: 50px;

	}
	.logo-box {
		width: 30px;
		height: 100px;
		margin: 20px;
	}
	.head-box {
		background: #ffffff;
		height: 55px;
		width: 100%;
		display: flex;
	}

	
	.head-tab {
		margin: 0 auto;
		width: 1200px;
		background-color: #ffffff;
	}

	.step-box {
		width: 1200px;
		height: 744px;
		background: url(../../../static/img/banner.png);
		background-repeat: no-repeat;
		background-color: #EFF2F9;
	}

	.content-box {
		padding: 25px 20px 60px 39px;
	}

	.step-title {
		font-size: 48px;
		font-weight: bold;
		color: #3D3D3D;
	}

	.content {
		display: flex;
		color: #3D3D3D;
		font-size: 16px;
		margin: 25px 0 15px 0;
		width: 64%;
	}

	.item-box {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 75px;
	}

	.step-item {
		display: flex;
		justify-content: center;
		align-items: center;

	}
	
	.holes-btn {
		width: 400px;
		height: 60px;
		background: #1677FF;
		color: #FFFFFF;
		border-radius: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 100px auto;
		font-size: 20px;
	}
	
	.circle {
		width: 32px;
		height: 32px;
		border-radius: 32px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		background: #1677FF;
		color: #ffffff;
		font-size: 14px;
	}

	.title {
		color: rgba(0, 0, 0, 0.88);
		font-size: 16px;
		margin-left: 8px;
	}

	.message-box {
		display: flex;
		justify-content: space-between;
		margin-top: 75px;
	}

	.submit-box {
		width: 1200px;
		background-color: #ffffff;
		margin-bottom: 50px;
	}	

	.line {
		width: 4px;
		height: 28px;
		background: #1677FF;
		margin-right: 8px;
	}

	.fontSize14 {
		font-size: 14px;
	}

	.fontSize24 {
		font-size: 24px;
	}

	.fontSize20 {
		font-size: 20px;
	}

	.colorBlack {
		color: #3D3D3D;
	}

	.color-gray {
		color: rgba(0, 0, 0, 0.45);
	}

	.uploadImg {
		width: 150px;
		height: 150px;
	}

	.marginLeft20 {
		margin-left: 20px;
	}

	.marginRight8 {
		margin-right: 8px;
	}

	.marginTop16 {
		margin-top: 16px;
	}
	.marginBottom32 {
		margin-bottom: 32px;
	}
	.marginRight58 {
		margin-right: 58px;
	}
	.img-item {
		position: relative;
		display: inline-block;
		width: 126px;
		height: 104px;
		margin-right: 9px;
		border-radius: 2px;
	}
	.video-box {
		height: 170px;
	}
	.check-box {
		width: 1190px;
		background: #FFFFFF;
		margin-top: 24px;
		padding-bottom: 30px;
		overflow: auto;
	}

	.input-box {
		padding: 48px 0 42px 48px;
		display: flex;
		align-items: center;
	}

	.submit-btn {  
		width: 118px;
		height: 32px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		border: 1px solid #1677FF;
		background: #1677FF;
		border-radius: 6px;
		color: #ffffff;
		cursor: pointer;
	}
	.cancel-btn {
		width: 118px;
		height: 32px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		background: #FFFFFF;
		border: 1px solid rgba(0, 0, 0, 0.15);
		border-radius: 6px;
		color: #000000;
		cursor: pointer;
	}
	.reset-btn {
		width: 90px;
		height: 36px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		border: 1px solid rgba(0, 0, 0, 0.15);
		background: #FFFFFF;
		border-radius: 6px;
		color: rgba(0, 0, 0, 0.88);

	}
	.top-title {
		display: flex;
		padding: 22px 0 38px 36px;
		align-items: center;
	}
	.mistake-title {
		white-space: nowrap;
		word-break: break-all;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.mistake-content {
		max-height: 55px;
		width: 100%;
		overflow-y: hidden;
		word-break: break-all;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.image-box {
		margin-left: 36px;
		width: 1105px;
		height: 364px;
		border-bottom: 0.5px solid rgba(0, 0, 0, 0.2);
		white-space: nowrap;
		word-break: break-all;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.image-item {
		width: 104px;
		height: 104px;
		margin-right: 16px;
		margin-top: 15px;
	}
	.reply-content {
		margin:  64px 0 37px 48px;
		color: #181818;
	}
	.reply-title {
		margin-bottom: 32px;
	}
	.submit-position {
		margin-left: 900px;
		margin-top: 60px;
	}

	.noDataTip {
		position: relative;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 675px;
		height: 275px;
		margin-top: 30px;
	}

	.noDataTip img {
		position: absolute;
		width: 100%;
		height: 100%;
	}

	.noDataTip span {
		position: absolute;
		color: #999999;
		bottom: 35px;
		left: 50%;
		font-size: 14px;
		transform: translateX(-50%);
	}

	.table-box {
		width: 1100px;
		margin-left: 30px;
	}

	.fix-box {
		width: 1200px;
		height: 928px;
		background-color: #ffffff;
	}

	.fix-item {
		padding: 48px 0 32px 40px;
		margin-bottom: 20px;
		width: 1000px;
	}

	.item {
		margin-bottom: 45px;
		border-bottom: 0.5px solid rgba(0, 0, 0, 0.2);
	}

	.circle-black {
		width: 8px;
		height: 8px;
		border-radius: 50%;
		background-color: #181818;
	}

	.pic-del {
		width: 22px;
		height: 22px;
		position: absolute;
		right: -14px;
		top: -5px;
		color: red;
	}
	.video-del {
		width: 24px;
		height: 24px;
		position: absolute;
		right: -20px;
		top: -4px;
		color: red;
	}
	.pointer {
		cursor: pointer;
	}
	.software-box {
		width: 1200px;
		height: 800px;
		background-color: #ffffff;
		padding: 20px 30px;
		box-sizing: border-box;
		overflow-y: auto;
		margin-bottom: 150px;
	}
	.software-box .head-title {
		font-size: 42px;
		font-weight: bold;
		color: #3D3D3D;
		display: block;
		margin-bottom: 12px;
	}
	.head-content {
		padding-bottom: 12px;
		display: block;
		font-size: 16px;
	}

	div>>>.el-upload--picture-card {
		border: none;
		width: 106px;
		height: 106px;
	}

	/*tab标签样式修改*/
	div>>>.el-tabs__header {
		margin: 0;
	}

	div>>>.el-tabs__nav {
		margin-left: 18px;
	}

	div>>>.el-tabs__item.is-active {
		color: #4E9CF8;
		font-size: 18px;
		font-weight: Bold;
	}

	div>>>.el-tabs__item {
		font-size: 18px;
		color: #181818;
		height: 64px;
		line-height: 64px;
	}

	div>>>.el-tabs__nav-wrap::after {
		height: 1px;
		background-color: #F7F7F7;
	}

	div>>>.el-tabs__active-bar {
		height: 3px;
		border-radius: 1.5px;
	}
	div>>>.el-textarea.is-disabled .el-textarea__inner {
		color: #000000 !important;
		width: 800px;
		height: 100px;
	}
	div>>>.el-tabs__item.is-active {
		color: #ffffff;
		background: #1677FF;
		border-bottom: #ffffff;
	}
	/* 顶部tab样式 */
	div>>>.el-tabs__header {
		background: #292B33;
	}
	div>>>.el-tabs__item  {
		color: #ffffff;
	}
	div>>>.div[data-v-536c2323] .el-tabs__item.is-active  {
		border-bottom: #292B33;
	}
	div>>>.el-tabs--card>.el-tabs__header .el-tabs__nav  {
		border: 1px solid #323233;
	}
	div>>>.el-tabs--card>.el-tabs__header .el-tabs__item {
		border-left: 1px solid #323233;
	}
	div>>>.el-tabs--card>.el-tabs__header {
		border-bottom: 1px solid #000;
	}
	div>>>.el-tabs__nav  {
		margin-left: 0px;
	}
	
</style>


// WEBPACK FOOTER //
// src/components/common/home.vue